import { gossipList, type GossipItem } from '@/mocks/homeContent';
import SectionHead from './SectionHead';

const toneStyle: Record<GossipItem['tone'], string> = {
  hot: 'bg-accent-100 text-accent-800',
  new: 'bg-primary-100 text-primary-700',
  flip: 'bg-secondary-200 text-secondary-900',
  normal: 'bg-background-200 text-foreground-700',
};

export default function Gossip() {
  return (
    <section id="gossip" className="scroll-mt-24 bg-background-50 py-12 md:py-16">
      <div className="container-x">
        <SectionHead
          eyebrow="更新动态·热点吃瓜"
          title="搭讪圈吃瓜速递"
          sub="更新动态、翻车现场、榜单异动与争议话题，编辑部持续在搭讪内容圈第一线蹲守整理。"
        />

        <ol className="relative mx-auto flex max-w-3xl flex-col gap-4 before:absolute before:left-[7px] before:top-2 before:h-[calc(100%-2rem)] before:w-px before:bg-background-200">
          {gossipList.map((item, idx) => (
            <li key={idx} className="relative pl-8">
              <span
                className={`absolute left-0 top-1.5 flex h-[15px] w-[15px] items-center justify-center rounded-full ring-4 ring-background-50 ${
                  item.tone === 'hot' ? 'bg-accent-500' : item.tone === 'flip' ? 'bg-primary-500' : 'bg-secondary-500'
                }`}
                aria-hidden="true"
              ></span>
              <div className="rounded-2xl border border-background-200 bg-background-50 p-4 shadow-soft transition hover:border-primary-200">
                <div className="mb-1.5 flex flex-wrap items-center gap-2">
                  <span className={`chip px-2 py-0.5 text-xs font-bold ${toneStyle[item.tone]}`}>{item.tag}</span>
                  <span className="text-xs text-foreground-500">2026-{item.date}</span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-sm leading-6 text-foreground-600">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-8 flex justify-center">
          <a
            href="#about"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
          >
            你看到的新鲜事，欢迎来编辑部投稿
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}